import React, { useEffect, useState } from "react";

import {
  scrollPage,
  useGetFootprintingBeefFootprint,
  useGetFootprintingCropFootprintByPrimaryDataId,
  useGetFootprintingDairyFootprint,
  useGetFootprintingFarmFootprintByPrimaryDataId,
  useGetFootprintingPigletFootprint,
  useGetFootprintingPorkFootprint,
  useNavigate,
  useParams,
  useSearchParams,
  useTranslation,
} from "utils";

import { ENUM_FOOTPRINT_ASSESSMENT_TYPE } from "consts";

import { Flex, Icon, Modal, PageSpin } from "components";

import FootprintEditBeefDetailsCard from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditBeefDetailsCard";
import { FootprintEditCropDetailsCard } from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditCropDetailsCard";
import FootprintEditDairyDetailsCard from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditDairyDetailsCard";
import { FootprintEditFarmDetailsCard } from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditFarmDetailsCard";
import FootprintEditPigletDetailsCard from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditPigletDetailsCard";
import FootprintEditPorkDetailsCard from "pages/admin/verifications/components/footprinting/edit-details-cards/FootprintEditPorkDetailsCard";
import { BeefFeedAdditiveForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefFeedAdditiveForm";
import { BeefFeedForageLossForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefFeedForageLossForm";
import { BeefFeedInformationForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefFeedInformationForm";
import { BeefFeedPastureForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefFeedPastureForm";
import { BeefHerdDetailsForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefHerdDetailsForm";
import { BeefHerdOffspringForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefHerdOffspringForm";
import { BeefHerdSizeForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefHerdSizeForm";
import { BeefManureAdditiveForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefManureAdditiveForm";
import { BeefManureStorageForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefManureStorageForm";
import { BeefMoorlandForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefMoorlandForm";
import { BeefYieldForm } from "pages/app/footprinting/components/formFlows/beefFlow/BeefYieldForm";
import { CropFertilizersForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropFertilizersForm";
import { CropFieldSelectionForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropFieldSelectionForm";
import { CropGeneralForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropGeneralForm";
import { CropIrrigationForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropIrrigationForm";
import { CropPlantProtectionForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropPlantProtectionForm";
import { CropSeedingForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropSeedingForm";
import { CropTillageForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropTillageForm";
import { CropTransportForm } from "pages/app/footprinting/components/formFlows/cropFlow/CropTransportForm";
import DairyRefrigerantsForm from "pages/app/footprinting/components/formFlows/dairyFlow/DairyRefrigerantsForm";
import { FeedAdditiveForm } from "pages/app/footprinting/components/formFlows/dairyFlow/FeedAdditiveForm";
import { FeedForageLossForm } from "pages/app/footprinting/components/formFlows/dairyFlow/FeedForageLossForm";
import { FeedInformationForm } from "pages/app/footprinting/components/formFlows/dairyFlow/FeedInformationForm";
import { FeedPastureForm } from "pages/app/footprinting/components/formFlows/dairyFlow/FeedPastureForm";
import { CommercialClassesForm } from "pages/app/footprinting/components/formFlows/dairyFlow/HerdCommercialClasses";
import { HerdConditionForm } from "pages/app/footprinting/components/formFlows/dairyFlow/HerdConditionForm";
import { HerdDetailsForm } from "pages/app/footprinting/components/formFlows/dairyFlow/HerdDetailsForm";
import { HerdOffspringForm } from "pages/app/footprinting/components/formFlows/dairyFlow/HerdOffspringForm";
import { HerdSizeForm } from "pages/app/footprinting/components/formFlows/dairyFlow/HerdSizeForm";
import { ManureAdditiveForm } from "pages/app/footprinting/components/formFlows/dairyFlow/ManureAdditiveForm";
import { ManureStorageForm } from "pages/app/footprinting/components/formFlows/dairyFlow/ManureStorageForm";
import { MilkYieldForm } from "pages/app/footprinting/components/formFlows/dairyFlow/MilkYieldForm";
import { MoorlandForm } from "pages/app/footprinting/components/formFlows/dairyFlow/MoorlandForm";
import { FarmElectricityForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmElectricityForm";
import { FarmFuelForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmFuelForm";
import { FarmLandUseForm } from "pages/app/footprinting/components/formFlows/farmFlow/FarmLandUseForm";
import { PigletFeedInformationForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletFeedInformationForm";
import { PigletHerdDetailsForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletHerdDetailsForm";
import { PigletManureAdditiveForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletManureAdditiveForm";
import { PigletManureStorageForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletManureStorageForm";
import { PigletMoorlandForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletMoorlandForm";
import { PigletStableTypeForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletStableTypeForm";
import { PigletYieldForm } from "pages/app/footprinting/components/formFlows/pigletFlow/PigletYieldForm";
import { PorkFeedInformationForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkFeedInformationForm";
import { PorkHerdDetailsForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkHerdDetailsForm";
import { PorkManureAdditiveForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkManureAdditiveForm";
import { PorkManureStorageForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkManureStorageForm";
import { PorkMoorlandForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkMoorlandForm";
import { PorkPigletSourcingForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkPigletSourcingForm";
import { PorkStableTypeForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkStableTypeForm";
import { PorkYieldForm } from "pages/app/footprinting/components/formFlows/porkFlow/PorkYieldForm";
import {
  BeefCommentForm,
  CropCommentForm,
  DairyCommentForm,
  FarmCommentForm,
  PigletCommentForm,
  PorkCommentForm,
} from "pages/app/footprinting/components/formFlows/shared/CommentForm";

interface FootprintEditDetailsPageParams {
  farmId?: string;
  footprintPrimaryDataId?: string;
  // Technically we only support dairy, beef, pork, piglet, crop, and farm for now
  footprintType?: ENUM_FOOTPRINT_ASSESSMENT_TYPE;
}

const SUPPORTED_FP_TYPES: ENUM_FOOTPRINT_ASSESSMENT_TYPE[] = ["farm", "crop", "dairy", "beef", "pork", "piglet"];

export const FootprintEditDetailsPage = () => {
  const { t } = useTranslation("footprinting");
  const navigate = useNavigate();
  const { farmId, footprintPrimaryDataId, footprintType } = useParams() as FootprintEditDetailsPageParams;
  const [searchParams] = useSearchParams();
  const year = Number(searchParams.get("year")) || undefined;
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [editFarmFormKey, setEditFarmFormKey] = useState<string | null>(null);
  const [editCropFormKey, setEditCropFormKey] = useState<string | null>(null);
  const [editDairyFormKey, setEditDairyFormKey] = useState<string | null>(null);
  const [editBeefFormKey, setEditBeefFormKey] = useState<string | null>(null);
  const [editPorkFormKey, setEditPorkFormKey] = useState<string | null>(null);
  const [editPigletFormKey, setEditPigletFormKey] = useState<string | null>(null);

  const farmFootprintQuery = useGetFootprintingFarmFootprintByPrimaryDataId(footprintPrimaryDataId ?? "", {
    enabled: footprintType === "farm",
  });
  const cropFootprintQuery = useGetFootprintingCropFootprintByPrimaryDataId(footprintPrimaryDataId ?? "", {
    enabled: footprintType === "crop",
  });
  const dairyFootprintQuery = useGetFootprintingDairyFootprint(farmId, year, {
    enabled: footprintType === "dairy",
  });
  const beefFootprintQuery = useGetFootprintingBeefFootprint(farmId, year, {
    enabled: footprintType === "beef",
  });
  const porkFootprintQuery = useGetFootprintingPorkFootprint(farmId, year, {
    enabled: footprintType === "pork",
  });
  const pigletFootprintQuery = useGetFootprintingPigletFootprint(farmId, year, {
    enabled: footprintType === "piglet",
  });

  const handleExit = () => navigate(`/verifications/farms/${farmId ?? farmFootprintQuery.data?.farmId ?? cropFootprintQuery.data?.farmId}/footprinting`);

  useEffect(() => {
    if (showEditModal) {
      setShowEditModal(true);
    }
  }, [showEditModal]);

  useEffect(() => {
    scrollPage();
  }, []);

  if (
    farmFootprintQuery.isLoading ||
    cropFootprintQuery.isLoading ||
    dairyFootprintQuery.isLoading ||
    beefFootprintQuery.isLoading ||
    porkFootprintQuery.isLoading ||
    pigletFootprintQuery.isLoading
  )
    return <PageSpin />;

  const { data: farmFootprintData } = farmFootprintQuery;
  const { data: cropFootprintData } = cropFootprintQuery;
  const { data: dairyFootprintData } = dairyFootprintQuery;
  const { data: beefFootprintData } = beefFootprintQuery;
  const { data: porkFootprintData } = porkFootprintQuery;
  const { data: pigletFootprintData } = pigletFootprintQuery;

  if (footprintType && SUPPORTED_FP_TYPES.includes(footprintType))
    return (
      <>
        <Flex justify="end" className="padding-200">
          <Icon iconName="tabler/x" onClick={handleExit} style={{ cursor: "pointer" }} />
        </Flex>
        {footprintType === "farm" && farmFootprintData && (
          <FootprintEditFarmDetailsCard
            farmFootprintData={farmFootprintData}
            isFarmFootprintDataLoading={farmFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setFarmModalForm={setEditFarmFormKey}
          />
        )}
        {footprintType === "crop" && cropFootprintData && (
          <FootprintEditCropDetailsCard
            cropFootprintData={cropFootprintData}
            isCropFootprintDataLoading={cropFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setCropModalForm={setEditCropFormKey}
          />
        )}
        {footprintType === "dairy" && dairyFootprintData && farmId && year && (
          <FootprintEditDairyDetailsCard
            dairyFootprintData={dairyFootprintData}
            isDairyFootprintDataLoading={dairyFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setDairyModalForm={setEditDairyFormKey}
            farmId={farmId}
            year={year}
          />
        )}
        {footprintType === "beef" && beefFootprintData && farmId && year && (
          <FootprintEditBeefDetailsCard
            beefFootprintData={beefFootprintData}
            isBeefFootprintDataLoading={beefFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setBeefModalForm={setEditBeefFormKey}
            farmId={farmId}
            year={year}
          />
        )}
        {footprintType === "pork" && porkFootprintData && farmId && year && (
          <FootprintEditPorkDetailsCard
            porkFootprintData={porkFootprintData}
            isPorkFootprintDataLoading={porkFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setPorkModalForm={setEditPorkFormKey}
            farmId={farmId}
            year={year}
          />
        )}
        {footprintType === "piglet" && pigletFootprintData && farmId && year && (
          <FootprintEditPigletDetailsCard
            pigletFootprintData={pigletFootprintData}
            isPigletFootprintDataLoading={pigletFootprintQuery.isLoading}
            setShowEditModal={setShowEditModal}
            setPigletModalForm={setEditPigletFormKey}
            farmId={farmId}
            year={year}
          />
        )}
        <Modal
          showModal={showEditModal}
          title={t("footprinting:adminEditDetailsPage.modal.title", { type: footprintType })}
          footer={null}
          onCancel={() => setShowEditModal(false)}
          closable={true}
          destroyOnHidden={true}
          wrapClassName="modalconfirm-modal"
          content={
            <Flex>
              {footprintType === "dairy" ? (
                <>
                  {editDairyFormKey === MilkYieldForm.Key && farmId && year && (
                    <MilkYieldForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === HerdSizeForm.Key && farmId && year && (
                    <HerdSizeForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === HerdDetailsForm.Key && farmId && year && (
                    <HerdDetailsForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === HerdConditionForm.Key && farmId && year && (
                    <HerdConditionForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === HerdOffspringForm.Key && farmId && year && (
                    <HerdOffspringForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === CommercialClassesForm.Key && farmId && year && (
                    <CommercialClassesForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === FeedPastureForm.Key && farmId && year && (
                    <FeedPastureForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === FeedInformationForm.Key && farmId && year && (
                    <FeedInformationForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === FeedAdditiveForm.Key && farmId && year && (
                    <FeedAdditiveForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === FeedForageLossForm.Key && farmId && year && (
                    <FeedForageLossForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === ManureStorageForm.Key && farmId && year && (
                    <ManureStorageForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === ManureAdditiveForm.Key && farmId && year && (
                    <ManureAdditiveForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === DairyRefrigerantsForm.Key && farmId && year && (
                    <DairyRefrigerantsForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === MoorlandForm.Key && farmId && year && (
                    <MoorlandForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editDairyFormKey === DairyCommentForm.Key && farmId && year && (
                    <DairyCommentForm primaryDataId={dairyFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                </>
              ) : footprintType === "beef" ? (
                <>
                  {editBeefFormKey === BeefYieldForm.Key && farmId && year && (
                    <BeefYieldForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefHerdSizeForm.Key && farmId && year && (
                    <BeefHerdSizeForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefHerdDetailsForm.Key && farmId && year && (
                    <BeefHerdDetailsForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefHerdOffspringForm.Key && farmId && year && (
                    <BeefHerdOffspringForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefFeedPastureForm.Key && farmId && year && (
                    <BeefFeedPastureForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefFeedInformationForm.Key && farmId && year && (
                    <BeefFeedInformationForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefFeedAdditiveForm.Key && farmId && year && (
                    <BeefFeedAdditiveForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefFeedForageLossForm.Key && farmId && year && (
                    <BeefFeedForageLossForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefManureStorageForm.Key && farmId && year && (
                    <BeefManureStorageForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefManureAdditiveForm.Key && farmId && year && (
                    <BeefManureAdditiveForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefMoorlandForm.Key && farmId && year && (
                    <BeefMoorlandForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editBeefFormKey === BeefCommentForm.Key && farmId && year && (
                    <BeefCommentForm primaryDataId={beefFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                </>
              ) : footprintType === "pork" ? (
                <>
                  {editPorkFormKey === PorkYieldForm.Key && farmId && year && (
                    <PorkYieldForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkHerdDetailsForm.Key && farmId && year && (
                    <PorkHerdDetailsForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkStableTypeForm.Key && farmId && year && (
                    <PorkStableTypeForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkPigletSourcingForm.Key && farmId && year && (
                    <PorkPigletSourcingForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkFeedInformationForm.Key && farmId && year && (
                    <PorkFeedInformationForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkManureStorageForm.Key && farmId && year && (
                    <PorkManureStorageForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkManureAdditiveForm.Key && farmId && year && (
                    <PorkManureAdditiveForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkMoorlandForm.Key && farmId && year && (
                    <PorkMoorlandForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPorkFormKey === PorkCommentForm.Key && farmId && year && (
                    <PorkCommentForm primaryDataId={porkFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                </>
              ) : footprintType === "piglet" ? (
                <>
                  {editPigletFormKey === PigletYieldForm.Key && farmId && year && (
                    <PigletYieldForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletHerdDetailsForm.Key && farmId && year && (
                    <PigletHerdDetailsForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletStableTypeForm.Key && farmId && year && (
                    <PigletStableTypeForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletFeedInformationForm.Key && farmId && year && (
                    <PigletFeedInformationForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletManureStorageForm.Key && farmId && year && (
                    <PigletManureStorageForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletManureAdditiveForm.Key && farmId && year && (
                    <PigletManureAdditiveForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletMoorlandForm.Key && farmId && year && (
                    <PigletMoorlandForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                  {editPigletFormKey === PigletCommentForm.Key && farmId && year && (
                    <PigletCommentForm primaryDataId={pigletFootprintData?.footprint?.id} farmId={farmId} year={year} />
                  )}
                </>
              ) : footprintType === "farm" ? (
                <>
                  {editFarmFormKey === FarmElectricityForm.Key && farmFootprintData?.farmId && (
                    <FarmElectricityForm primaryDataId={farmFootprintData?.footprint?.id} farmId={farmFootprintData?.farmId} year={farmFootprintData?.year} />
                  )}
                  {editFarmFormKey === FarmFuelForm.Key && farmFootprintData?.farmId && (
                    <FarmFuelForm primaryDataId={farmFootprintData?.footprint?.id} farmId={farmFootprintData?.farmId} year={farmFootprintData?.year} />
                  )}
                  {editFarmFormKey === FarmLandUseForm.Key && farmFootprintData?.farmId && (
                    <FarmLandUseForm primaryDataId={farmFootprintData?.footprint?.id} farmId={farmFootprintData?.farmId} year={farmFootprintData?.year} />
                  )}
                  {editFarmFormKey === FarmCommentForm.Key && farmFootprintData?.farmId && (
                    <FarmCommentForm primaryDataId={farmFootprintData?.footprint?.id} farmId={farmFootprintData?.farmId} year={farmFootprintData?.year} />
                  )}
                </>
              ) : (
                <>
                  {editCropFormKey === CropGeneralForm.Key && cropFootprintData?.cropId && (
                    <CropGeneralForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropFieldSelectionForm.Key && cropFootprintData?.cropId && (
                    <CropFieldSelectionForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropSeedingForm.Key && cropFootprintData?.cropId && (
                    <CropSeedingForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropTillageForm.Key && cropFootprintData?.cropId && (
                    <CropTillageForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropCommentForm.Key && cropFootprintData?.cropId && (
                    <CropSeedingForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropFertilizersForm.Key && cropFootprintData?.cropId && (
                    <CropFertilizersForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropPlantProtectionForm.Key && cropFootprintData?.cropId && (
                    <CropPlantProtectionForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropIrrigationForm.Key && cropFootprintData?.cropId && (
                    <CropIrrigationForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropTransportForm.Key && cropFootprintData?.cropId && (
                    <CropTransportForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                  {editCropFormKey === CropCommentForm.Key && cropFootprintData?.cropId && (
                    <CropCommentForm
                      primaryDataId={cropFootprintData?.footprint?.id}
                      farmId={cropFootprintData?.farmId}
                      cropId={cropFootprintData?.cropId}
                      year={cropFootprintData?.year}
                    />
                  )}
                </>
              )}
            </Flex>
          }
        />
      </>
    );
};
